import React from "react";
import "../scss/button.scss";
import "../scss/ApplicationInProgress.scss";
import { ReactComponent as Clipboard } from "../images/clipboard.svg";
import { ReactComponent as StarfinLogo } from "../images/stashfin-logo.svg";
import PageHeader from "../components/PageHeader";
import { useNavigate } from "react-router-dom";

function ApplicationInProgress() {

  const navigate = useNavigate();

  const exitApplication = () => {
    const partnrrdrct = localStorage.getItem('partnerRedirect')
    if (partnrrdrct) {
      window.location.href = partnrrdrct
    } else {
      navigate('/')
    }
  }

  return (
    <div className="application-in-progess-page-container">
      <PageHeader />
        <div className="application-in-progress">
          <div className="checkmark-container">
            <div className="checkmark-circle">
              <Clipboard className="checkmark-icon" />
            </div>
          </div>
          <h1 className="title">Application in Review</h1>
          <p className="subtitle">
            Your application has been successfully submitted. You will be
            notified within <span className="time">24</span> to{" "}
            <span className="time">48</span> hours
          </p>
          <br></br>
          <br></br>
          <p className="subtitle">Thank You!</p>
        </div>
        <div className="bottom-footer">
          <p className="powered-by">
            {" "}
            Powered by <StarfinLogo />{" "}
          </p>
          <button
            type="submit"
            className="btn btn-primary"
            onClick={exitApplication}
          >
            Close
          </button>
        </div>
    </div>
  );
}

export default ApplicationInProgress;
